import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { EventsService } from '../../../calendar/services/events-service/events.service';
import { Calendar } from '../../../calendar/models/calendar';
import { DatewiseEvents } from '../../../calendar/models/datewise-events';
import { SwiperConfigInterface, SwiperNavigationInterface } from 'ngx-swiper-wrapper';
declare var platform;

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss']
})
export class DateSelectorComponent extends ComponentBase implements OnInit {

  calendar: Calendar;
  todaysdate: string = new Date().toISOString().split('T')[0];
  selectedDay: DatewiseEvents;
  subscription: Subscription;
  platform: string;
  activeSlide: number;

  config: SwiperConfigInterface = {
    slidesPerView: 7,
    slidesPerGroup: 7,
    navigation: false,
    breakpoints: {
      1000: {
        slidesPerView: 6,
        slidesPerGroup: 6,
      },
      900: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
      760: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      600: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    }
  };
  private navigation: SwiperNavigationInterface = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }

  constructor(private eventsService: EventsService) {
    super();
  }

  ngOnInit() {
    if (platform == 'browser') {
      this.config.navigation = this.navigation;
    }
    this.platform = platform;
    this.subscription = this.eventsService.getEvents()
      .subscribe(events => {
        this.calendar = events;
        this.calendar.datewise_events.forEach((day, index) => {
          if (this.todaysdate == day.event_date.split('T')[0]) {
            this.selectedDay = day;
            this.activeSlide = index;
          }
        });
        if (!this.selectedDay) {
          this.selectedDay = this.calendar.datewise_events[0];
        }
      });
    this.addSubscription(this.subscription);
  }

  onClick(datewiseEvents: DatewiseEvents) {
    this.selectedDay = datewiseEvents;
  }

  onSwipe(index: number) {
    this.selectedDay = this.calendar.datewise_events[index];
  }

}
